const backgroundColors = {
  gray100: '#f5f5f5',
  darkBlue: '#253345',
  selectedBlue: '#515565',
  lightBlue: '#F3F8FF',
};
const uiColors = {
  gray300: '#e0e0e0',
  gray400: '#bdbdbd',
  white: '#FFFFFF',
  black: '#000000',
};
const contentColors = {
  gray600: '#757575',
  gray900: '#212121',
  gray800: '#424242',
  disabled: '#666666',
  disabledSecondary: '#6e6e6e',
  highlight: '#008F85',
};
export const grays = {
  gray50: '#fafafa',
  gray100: backgroundColors.gray100,
  gray300: uiColors.gray300,
  gray400: uiColors.gray400,
  gray600: contentColors.gray600,
  gray800: contentColors.gray800,
  gray900: contentColors.gray900,
};
export const accent = {
  positive: '#388E3C',
  positiveDark: '#00600F',
  positiveBackground: '#E8F5E9',
  positiveBright: '#10B981',
  attention: '#FFD43C',
  attentionDark: '#665518',
  attentionBackground: '#FFF6D8',
  negative: '#DC2642',
  negativeDark: '#A5000D',
  negativeBackground: '#FFEBEE',
  action: '#0351ab',
  actionLight: '#e3f2fd',
  actionColorDark: '#00397b',
};

export const avatarsColors = {
  darkIndigo: '#3A1F8E',
  darkPurple: '#7151CA',
  sofiaPink: '#EA3B89',
  darkRed: '#AC3E55',
  darkOrange: '#ac535a',
  eggYolk: '#F8CB45',
  saladish: '#C7B656',
  grassGreen: '#377C50',
  navy: '#2D508C',
  brightBlue: '#659BF5',
};

export const brandColors = {
  primary: '#057c99',
  surface: '#eef6f8',
  border: '#c0dee5',
  brandRed: '#D52839',
  brandBlue: '#1A7DFF',
  brandGreen: '#23A287',
  brandYellow: '#F5B82E',
  brandPink: '#E56B6F',
  ametystPurple: '#8C68C8',
  raspberryPink: '#D957A3',
  amberGlow: '#FD9347',
  lightAmetystPurple: '#F3F0F9',
  lightRaspberryPink: '#FBEEF6',
  lightAmberGlow: '#FFF4ED',
  hanBlue: '#576FD9',
  paradiso: '#368C76',
};

export const decorativeColors = {
  warningLight: '#FFF9E4',
  lightSun: '#FFF3D9',
  sun: '#FFC135',
  darkSun: '#654E1A',
  lightPumpkin: '#FBF1E6',
  pumpkin: '#D97706',
  darkPumpkin: '#653B1C',
  lightCoral: '#FFE1E2',
  coral: '#FD6B6F',
  darkCoral: '#652B2C',
  lightBubbleGum: '#FEE1F1',
  bubbleGum: '#FC6BB8',
  darkBubbleGum: '#652B4A',
  lightLavender: '#F2E5FF',
  lavender: '#BE7CFF',
  darkLavender: '#5F3E80',
  lightViolet: '#E3E0FF',
  violet: '#7362FF',
  darkViolet: '#453B99',
  surfaceSecondary: '#FAFCFF',
  surfaceTertiary: '#FDFDFF',
  sky: '#1976D2',
  darkSky: '#0D3B69',
  lightTeal: '#D3F6F8',
  teal: '#23D3DE',
  darkTeal: '#0E5459',
  lightEmerald: '#DBF6E5',
  emerald: '#4CD47F',
  darkEmerald: '#1E5533',
  purple: '#4F46E5',
  purpleLight: '#E9E9F5',
};

const colors = {
  ...grays,
  ...uiColors,
  ...contentColors,
  ...backgroundColors,
  ...decorativeColors,
  ...accent,
  ...brandColors,
  transparent: 'rgba(0,0,0,0)',
  linkedin: '#0A66C2',
};

export default colors;
